import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-reconexion',
  templateUrl: './modal-reconexion.component.html',
  styleUrls: ['./modal-reconexion.component.scss']
})
export class ModalReconexionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
